import styled from "styled-components";
import { type SpaceProps, type BorderProps, space, border } from "styled-system";
import { ToggleIconWrapper } from "../globals/IconWrapper";
import { theme } from "../theme/lexusTheme";
import * as Table from "../../../../components/styles/Table";

export const Wrapper = styled.div`
    padding: 0;
`;

export const Header = styled.header<{ isPdf?: boolean }>`
    display: ${({ isPdf }) => (isPdf ? "block" : "flex")};
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.space[3]}px 0;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: start;
    text-transform: uppercase;
    color: ${theme.colors.black};
    border-bottom: 1px solid ${theme.colors.platinumLight};
    cursor: pointer;

    ${ToggleIconWrapper} {
        align-self: center;
        margin-left: auto;

        @media print {
            display: none;
        }
    }

    html[dir="rtl"] & {
        ${ToggleIconWrapper} {
            margin-left: 0;
            margin-right: auto;
        }
    }
`;

export const HeaderVisual = styled.span`
    display: flex;
    margin-right: ${theme.space[2]}px;
    color: ${theme.colors.black};

    html[dir="rtl"] & {
        margin-left: ${theme.space[2]}px;
        margin-right: 0;
    }
`;

export const Body = styled.div<{ noSpacing?: boolean; noBorder?: boolean } & SpaceProps & BorderProps>`
    padding: ${({ noSpacing }) => (noSpacing ? 0 : `${theme.space[3]}px`)};
    border: ${({ noBorder }) => (noBorder ? "none" : `1px solid ${theme.colors.platinumLight}`)};
    border-top: none;
    ${space}
    ${border}

    /* Specific style for alignment in compare */
    [role="cell"] {
        ${Table.InnerCol} {
            padding: ${theme.space[2]}px;
        }
        &:first-of-type {
            ${Table.InnerCol} {
                padding-left: 0;
            }
        }
    }

    html[dir="rtl"] & {
        [role="cell"] {
            &:first-of-type {
                ${Table.InnerCol} {
                    padding-right: 0;
                }
            }
        }
    }
`;

export const Item = styled.div<{ isPdf?: boolean } & SpaceProps & BorderProps>`
    padding-top: ${({ isPdf }) => (isPdf ? 0 : theme.space[3])}px;
    border-top: 1px solid ${theme.colors.platinumLight};
    &:first-child {
        border: none;
    }
    ${space}
    ${border}
`;
